module.exports = __webpack_public_path__ + "img/wellwellwell-session-2.a1eb9bd4.png";